import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export function PublicMenuSkeleton() {
  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      {/* Header Skeleton */}
      <div className="bg-white pb-4 shadow-sm">
        {/* Banner/Cover */}
        <div className="h-32 w-full bg-gray-200 animate-pulse" />
        
        {/* Restaurant Info */}
        <div className="px-4 -mt-8 relative z-10 flex flex-col items-center">
          <div className="w-20 h-20 rounded-full border-4 border-white bg-white shadow-sm overflow-hidden">
            <Skeleton className="w-full h-full rounded-full" />
          </div>
          <div className="mt-3 text-center space-y-2 w-full max-w-xs">
            <Skeleton className="h-6 w-3/4 mx-auto" />
            <Skeleton className="h-4 w-1/2 mx-auto" />
          </div>
        </div>

        {/* Search Bar */}
        <div className="px-4 mt-6">
          <Skeleton className="h-10 w-full rounded-lg" />
        </div>

        {/* Categories */}
        <div className="mt-6 px-4 flex space-x-3 overflow-hidden">
          {[1, 2, 3, 4].map((i) => (
            <Skeleton key={i} className="h-8 w-24 rounded-full flex-shrink-0" />
          ))}
        </div>
      </div>

      {/* Menu Items Grid */}
      <div className="p-4 space-y-6">
        {[1, 2].map((category) => (
          <div key={category} className="space-y-4">
            <Skeleton className="h-6 w-32" />
            <div className="grid grid-cols-1 gap-4">
              {[1, 2, 3].map((item) => (
                <div key={item} className="bg-white p-3 rounded-xl shadow-sm flex gap-3 h-28">
                  <div className="flex-1 space-y-2 py-1">
                    <Skeleton className="h-4 w-3/4" />
                    <Skeleton className="h-3 w-full" />
                    <div className="pt-2">
                      <Skeleton className="h-4 w-16" />
                    </div>
                  </div>
                  <Skeleton className="w-24 h-full rounded-lg flex-shrink-0" />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
